import { render, staticRenderFns } from "./OurKits.vue?vue&type=template&id=0a002c5a&scoped=true&"
import script from "./OurKits.vue?vue&type=script&lang=js&"
export * from "./OurKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a002c5a",
  null
  
)

export default component.exports